import { DYNAMICFORMS_URL } from "utils/constants";
import { ENDPOINTSDYNAMICFORMS } from "utils/endpoints";
import { http } from "utils/http";
export const postDataCollection = (data,method) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollection,
    method: method,
 data,
 params:{
    Confirm:false
 }
}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});

export const postDataCollectionById = (Id) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.getDataCollectionById,
    method: 'get',

 params:{
 Id
 }
}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});

export const deleteDataCollection = (id) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollection,
    method: 'delete',
params:{
    id
}
}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});




export const deleteDataCollectionProperty = (id) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollectionProperties,
    method: 'delete',
params:{
    id
}
}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});


export const postPropertyDataCollection = (data,method) => http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollectionProperties,
    method: method,
 data
}).then((res) => {
    return res.data
}).catch((err) => {
     
    return Promise.reject(err);
});



export const getDataCollection = (async (pageNumber: number, pageSize: number) => await http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollection,
    method: 'get',
 params:{  
                PageNumber: pageNumber,
        PageSize: pageSize,
     }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)



export const getDataCollectionById = (async (
id) => await http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollection,
    method: 'get',
    params:{

         id
        }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const getDataCollectionProperties = (async (
    pageNum,  pageSize ,DynamicFormPropertyId,orderBy, filterlist 
) => await http({
    baseURL:DYNAMICFORMS_URL,
    url: ENDPOINTSDYNAMICFORMS.DynamicFormApis.DynamicFormProperty.dataCollectionProperties,
    method: 'get',
    params:{

         PageNumber: pageNum,
         PageSize: pageSize,
         DynamicFormPropertyId,
              OrderByString: orderBy,
        FilterString: filterlist,
        }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)